import { Container, Grid } from "@mui/material";
import styled from "@emotion/styled";
import {Typography} from "@mui/material";
import Logo from "../../../assets/logo.png";
import Telegram from "../../../assets/Telegram.png";
import Twitter from "../../../assets/Twitter.png";


const FooterContainer = styled(Container)`
    padding-top: 50px;
    padding-bottom: 50px;
    background-color: #000024;
    @media (max-width: 749px){
        padding-top: 20px;
        padding-bottom: 20px;
    }
`
const FooterImg = styled.img`
    width:222px;
    max-width: 100%;
    height:auto;
`
const P = styled.p`
    color:#fff;
    font-size: 15px;
    font-family: poppins-light;
    width: 60%;
    @media (max-width: 1200px) and (min-width: 1001px){
        width:80%;
    }
    @media (max-width: 1000px){
        width:90%;
        font-size: 13px;
    }
`
const FooterHeading = styled(Typography)`
    color:#fff;
    font-family :poppins-m ;
    font-size: 22px;
    @media (max-width: 600px){
        margin-top:20px;
    }
`
const FooterLinks = styled.p`

`
const Link = styled.a`
    color:#fff;
    font-family: poppins-light;
    font-size:16px;
    margin-top:10px;
    text-decoration: none;
    @media (max-width: 1000px){
        font-size: 13px;
    }
`
const SociaImg = styled.a`
    margin-right: 10px;
`
const CopyContainer = styled(Container)`
    background-color: #01014D;
`
const CopyRightText = styled.p`
    color:#fff;
    font-family: poppins-light;
    font-size: 15px;
    text-align: center;
`
const Footer = () => {
    return(
        <>
        <FooterContainer maxWidth="xxl">
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12} sm={6} md={5}>
                        <div>
                            <FooterImg src={Logo} />
                        </div>
                        <P></P>
                    </Grid>
                    <Grid item xs={12} sm={3} md={4}>
                        <FooterHeading variant="h2">Quick links</FooterHeading>
                        <FooterLinks><Link href="#home">Home</Link></FooterLinks>
                        <FooterLinks><Link href="#about">About</Link></FooterLinks>
                        <FooterLinks><Link href="#howitworks">How It Works</Link></FooterLinks>
                        <FooterLinks><Link href="#details">Token Details</Link></FooterLinks>
                        <FooterLinks><Link href="#faq">FAQ</Link></FooterLinks>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                        <FooterHeading variant="h2">Contact us</FooterHeading>
                        <FooterLinks><Link href="">contact@pulsemixer.com</Link></FooterLinks>
                        <SociaImg href="https://t.me/pulsemixerorg" target="blank"><img src={Telegram} alt="" /></SociaImg>
                        <SociaImg href="https://twitter.com/pulsemixerorg" target="blank"><img src={Twitter} alt="" /></SociaImg>
                    </Grid>
                </Grid>
            </Container>
        </FooterContainer>
        <CopyContainer maxWidth="xxl">
                <Grid container>
                    <Grid item xs={12}>
                        <CopyRightText>© 2023 Pulse Mixer. All Rights Reserved.</CopyRightText>
                    </Grid>
                </Grid>
        </CopyContainer>
        </>
    );
}

export default Footer;